import React from 'react';
import { ApolloError, gql } from '@apollo/client';
import { ForgotPasswordController, ForgotPasswordControllerProps } from './ForgotPassword.controller';
import { useSendPasswordResetEmailMutation } from '../../../models/graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';

export type ForgotPasswordApolloProps = Omit<
  ForgotPasswordControllerProps,
  'loading' | 'sendResetPassword' | 'requestError' | 'resetSent'
> & {
  //
};

gql`
  mutation SendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email)
  }
`;

export const ForgotPasswordApollo = (): JSX.Element => {
  let requestError: string | JSX.Element = '';
  let loading = false;
  let resetSent = false;

  const [
    sendResetPassword,
    { loading: sendResetPasswordLoading, error: sendResetPasswordError, data: sendResetPasswordData }
  ] = useSendPasswordResetEmailMutation({
    fetchPolicy: 'no-cache'
  });

  if (sendResetPasswordLoading) {
    loading = true;
    requestError = '';
  }

  if (sendResetPasswordError) {
    const errorForRemapping = sendResetPasswordError as ApolloError;
    requestError = remapApolloErrors(errorForRemapping);
    loading = false;
  }

  if (sendResetPasswordData?.sendPasswordResetEmail) {
    resetSent = true;
  }

  const args: ForgotPasswordControllerProps = {
    loading,
    requestError,
    resetSent,
    sendResetPassword
  };

  return <ForgotPasswordController {...args} />;
};
